export default "__VITE_ASSET__46960e39__"